'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherCheckCircle, FeatherTrendingUp, FeatherXCircle } from '@subframe/core';
import { StatsCard } from '@/shared/components/ui';
import type { TrialListSummary } from '../types';
interface TrialListSummaryCardsProps {
  summary: TrialListSummary;
}
export function TrialListSummaryCards(t0) {
  const $ = _c(17);
  const {
    summary
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherCheckCircle className="text-success-600" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== summary.totalAtivos) {
    t2 = <StatsCard label="Trials ativos" value={summary.totalAtivos} icon={t1} />;
    $[1] = summary.totalAtivos;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherAlertTriangle className="text-warning-600" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== summary.vencendoEmAteSeteDias) {
    t4 = <StatsCard label={"Vencendo em \u22647 dias"} value={summary.vencendoEmAteSeteDias} icon={t3} />;
    $[4] = summary.vencendoEmAteSeteDias;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherXCircle className="text-error-600" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== summary.expiradosSemAcao) {
    t6 = <StatsCard label={"Expirados sem a\xE7\xE3o"} value={summary.expiradosSemAcao} icon={t5} />;
    $[7] = summary.expiradosSemAcao;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FeatherTrendingUp className="text-brand-600" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== summary.convertidosNoMes) {
    t8 = <StatsCard label={"Convertidos no m\xEAs"} value={summary.convertidosNoMes} icon={t7} />;
    $[10] = summary.convertidosNoMes;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t4 || $[14] !== t6 || $[15] !== t8) {
    t9 = <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">{t2}{t4}{t6}{t8}</div>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}